import React from 'react';
import './travel.css';

const TravelInformation = () => {
  // Determine the appropriate map link based on the user's mobile platform.
  const getMapLink = () => {
    const query = encodeURIComponent("Shalamar Hospital, Lahore, Pakistan");
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      // For Android, use the geo URI (which many devices pass to Google Maps)
      return `geo:0,0?q=${query}`;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // For iOS, use Apple Maps URL scheme
      return `http://maps.apple.com/?q=${query}`;
    }
    // Otherwise, fall back to the Google Maps search URL
    return `https://www.google.com/maps/search/?api=1&query=${query}`;
  };

  const fullMapLink = getMapLink();

  return (
    <div className="travel-info">
      <h2>Accomodation</h2>
      <p>
        For Accomodation, you may send an email to{' '}
        <a href="mailto:conference.accomodation@smdc.edu.pk">
          conference.accomodation@smdc.edu.pk
        </a>
      </p>
      <h2>Travel Information</h2>
      <p>
        For Traveling Information, you may send an email to{' '}
        <a href="mailto:conference.travel@smdc.edu.pk">
          conference.travel@smdc.edu.pk
        </a>
      </p>
      <hr />
      <div className="map-container">
        {/* Interactive Google Map embed for Shalamar Hospital */}
        <iframe
          title="Shalamar Hospital Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3399.1381606307937!2d74.3772570765688!3d31.5752589444265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39191ac9af9d7edf%3A0xa625f11332d699cb!2sShalamar%20Hospital!5e0!3m2!1sen!2s!4v1744178047561!5m2!1sen!2s"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
        ></iframe>
      </div>
      
      {/* Button to open the map in a new tab or the native maps app on mobile */}
      <div className="open-map-container">
        <button
          className="open-map-btn"
          onClick={() => window.open(fullMapLink, "_blank")}
        >
          Open Map
        </button>
      </div>
    </div>
  );
};

export default TravelInformation;
